window.addEventListener('load', () => {
    videojs.addLanguage('fr', {
        "The media could not be loaded, either because the server or network failed or because the format is not supported.": "Tu n'es pas abonné ou il y a un problème réseau."
    });

    let $video = $('#z-video');
    if ($video.length) {
        // let videoOffsetY = $video.offset().top + ($video.innerHeight() * 75 / 100);
        //
        // // Video out of screen
        // window.addEventListener('scroll', () => {
        //     if (window.scrollY >= videoOffsetY) {
        //         $video.addClass('tiny');
        //     } else {
        //         $video.removeClass('tiny');
        //     }
        // });

        // Init VideoJS library
        if (document.getElementById('z-video')) {
            videojs.options.hls.overrideNative = true;
            videojs.options.overrideNative = true;

            let player = videojs("z-video", {
                language: 'fr'
            })
            .ready(function () {
                this.src({
                    type: $('#z-video').attr('data-type') || 'application/x-mpegURL',
                    src: $('#z-video').attr('data-src'),
                    overrideNative: true
                });

                this.hotkeys({
                    volumeStep: 0.1,
                    seekStep: 5,
                    enableVolumeScroll: false,
                    enableHoverScroll: true
                });

                this.contextmenuUI({
                    keepInside: true,
                    content: [
                        {
                            label: 'Play/Pause',
                            listener: () => {
                                this.controlBar.playToggle.handleClick();
                            }
                        },
                        {
                            label: 'Mute',
                            listener: () => {
                                this.controlBar.volumePanel.muteToggle.handleClick();
                            }
                        },
                        {
                            label: 'Fullscreen',
                            listener: () => {
                                this.controlBar.fullscreenToggle.handleClick();
                            }
                        },
                    ]
                })
            });
        }
    }
});
